import { h } from '@stencil/core';

const Icon = ({ width = '1rem', height = 'auto' }) => {
  return (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg" aria-hidden="true" class="smb-SvgIcon smb-SvgIcon--ready" viewBox="0 0 16 16">
      <g fill="none" fill-rule="evenodd">
        <path d="M0 0h16v16H0z" />
        <path
          d="m6.851 11.026.02.02 4.86-4.862a.657.657 0 0 0-.928-.929L6.867 9.192 4.677 7a.657.657 0 1 0-.93.928l3.1 3.1.004-.003ZM8 1.333A6.67 6.67 0 0 1 14.667 8 6.67 6.67 0 0 1 8 14.667 6.67 6.67 0 0 1 1.333 8 6.67 6.67 0 0 1 8 1.333Z"
          fill="#559C56"
        />
      </g>
    </svg>
  );
};

export default Icon;
